import { useMutation } from "react-query";
import http from "infra/http";

import { createFormData } from "infra/helpers/createFormData";
import { AxiosError } from "axios";
import { EquipamentoRealizarManutencaoForm } from "core/features/manutencao/typings/index";

function useRealizarManutencaoEquipamentos(manutencaoId: string) {
  return useMutation<
    { id: string; equipamentosIds: string },
    AxiosError,
    EquipamentoRealizarManutencaoForm
  >(
    "/v1/manutencao",
    async (form: EquipamentoRealizarManutencaoForm) => {
      const formData = createFormData(form.arquivos || [], form, "files", "arquivos");
      const { data } = await http.post(
        `/v1/manutencao/${manutencaoId}/realizacao/equipamento/${form.id}`,
        formData
      );

      return data;
    },
    { retry: false }
  );
}

export default useRealizarManutencaoEquipamentos;
